import 'Components/AppComponents/WindTurbine/WindTurbine.css';
import CSS from 'csstype';
import { GameHelper } from 'Helpers/GameHelper';

type WindTurbineProps = {
    containerStyles: CSS.Properties;
    bladeStyles?: CSS.Properties;
    poleStyles?: CSS.Properties;
};

const WindTurbine = ({ containerStyles, poleStyles }: WindTurbineProps) => {
    return (
        <div className={`absolute`} style={{...containerStyles, zIndex: 50, width: '40px'}}>
            <img className="absolute blade z-10 blur-8" src={'/images/WindmillPropeller.png'} alt="fan-blades" style={{ bottom: '-11px', left: '-11.2px', animation: `rotation ${GameHelper.randomGenerator(4, 7)}s infinite linear` }} />
            <img className="absolute pole blur-8" style={poleStyles} src={'/images/WindmillStand.png'} alt="fan-pole" />
        </div>
    );
};

export default WindTurbine;
